import { render, staticRenderFns } from "./PurPD_Items.vue?vue&type=template&id=e3b2283a"
import script from "./PurPD_Items.vue?vue&type=script&lang=js"
export * from "./PurPD_Items.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports